
import axios from 'axios';

import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
/**
 * Secure Medication Service
 * Uses backend API endpoints instead of direct Firestore access
 */

// Search medications by name
export async function searchMedications(searchTerm) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/medications/search`, {
      params: { q: searchTerm, limit: 25 },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data.map(med => ({
        label: med.baseName,
        id: med.rxNormConceptId,
        baseName: med.baseName,
        dosage: med.dosage,
        route: med.route,
        brandName: med.brandName,
        rxNormConceptId: med.rxNormConceptId
      }));
    }

    throw new Error('Failed to search medications');
  } catch (error) {
    console.error('Error searching medications:', error);
    throw error;
  }
}

// Get medication by ID
export async function getMedicationById(medicationId) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/medications/${medicationId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get medication');
  } catch (error) {
    console.error('Error getting medication:', error);
    throw error;
  }
}

// Get frequently used medications for a user
export async function getFrequentlyUsedMedications(userId) {
  try {
    const token = await getAuthToken();
    const response = await axios.get(`${API_BASE}/clinical/medications/frequently-used`, {
      params: { userId },
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      return response.data;
    }

    throw new Error('Failed to get frequently used medications');
  } catch (error) {
    console.error('Error getting frequently used medications:', error);
    throw error;
  }
}
